import React, { useContext,useEffect } from 'react'
import learn from '../images/learn.svg'
import image2 from '../images/5099304.jpg'
import Common from '../component/Common'
import headimg from '../images/Friendly Ones Avatar and Backdrop.svg'
import logo from '../images/tshirt-front.png'
import Offer from '../component/Offer'
import { AuthContext } from '../auth/auth'
import { NavLink, Redirect } from 'react-router-dom'
import mockup from '../images/Google Pixel 4.png'
import blob from '../images/blob.svg'
import vector1 from '../images/Vector3.png'
import one from '../images/undraw_Dev_focus_re_6iwt.svg'
import two from '../images/undraw_Experts_re_i40h.svg'
import three from '../images/undraw_Wall_post_re_y78d.svg'
import four from '../images/undraw_Profile_re_4a55.svg'
import five from '../images/undraw_Processing_re_tbdu.svg'
import chooseus from '../images/chooseus.svg'
import bell from '../images/bell.gif'

const Home = () => {
    useEffect(() => {
        document.title = "CareerGrads | Educating Tomorrow"
    }, [])
    return (
        <> <Common name='Learn With Experts on '
            imgsrc={headimg}
            visit='/services'
            btname='Get Started'
            content='Providing industry standard Training and Projects to students to find their dream job'
            side={'order-lg-last '}
        />
            <div className="container mt-5 ">
                <div className="mx-auto py-5 overflow-hidden">
                    <div className="text-center">
                        <div className="row">
                            <div className="col-10 col-md-6 mx-auto">
                                <img src={image2} alt="sample" className="img-fluid img-responsive" />
                            </div>
                            <div className="col-10 mt-4 col-md-6 d-flex justify-content-center flex-column text-left mx-auto">
                                <h1 className="font-weight-bold">
                                    Learn Wherever you can!
                            </h1>
                                <h5>
                                    Discover unique ways to learn to get the better results. Get hands-on learning that stays forever with you.
                            </h5>
                                <div className="text-dark">
                                    <ul className="mt-4 list_style">
                                        <li className="mt-3"><i style={{ marginRight: '8px' }} class="fa fa-chevron-circle-right" aria-hidden="true"></i>Personalized learning content designed by qualified experts and customized as per the individual's needs</li>
                                        <li className="mt-3"><i style={{ marginRight: '8px' }} class="fa fa-chevron-circle-right" aria-hidden="true"></i>Practice based learning with unlimited questions designed by experts</li>
                                        <li className="mt-3"><i style={{ marginRight: '8px' }} class="fa fa-chevron-circle-right" aria-hidden="true"></i>Performance/Practical based Learning with complete feedback and detailed analysis of your strengths and weaknesses.</li>
                                        <li className="mt-3"><i style={{ marginRight: '8px' }} class="fa fa-chevron-circle-right" aria-hidden="true"></i>Continuous nurturing and guidance by CareerGrads Faculty Team.</li>
                                    </ul>
                                </div>
                                <div className="mt-3">
                                    <NavLink to="/services" class="btn btn-success p2 bg-gradient">Learn with CareerGrads</NavLink>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            {/* --------------------------- Offer Section...-------------------------------------- */}
            <Offer />

            {/* --------------------------- Offer Section...-------------------------------------- */}
            <img src={vector1} className="vector2 overflow-hidden" />
            <div className="container">
                <div className="mt-5  py-5 overflow-hidden">
                    <div className="">
                        <div className="row">
                            <div className="col-10 col-md-6 d-flex justify-content-center flex-column mx-auto order-lg-1 order-2
                            animate__animated animate__fadeInLeftBig">
                                <h1 className="font-weight-bold mb-3">
                                    Do You Owe Any Skills?
                                </h1>
                                <h5>
                                    Ask The Question, Learn With Perfection, Lead With Conviction!
                                </h5>
                                <div >
                                    <ul className="mt-4 list_style text-left" >
                                        <li className="mt-3"><i class="fa fa-chevron-circle-right" aria-hidden="true" style={{ marginRight: '8px' }}></i>Become famous by answering the queries & doubts of students</li>
                                        <li className="mt-3"><i class="fa fa-chevron-circle-right" aria-hidden="true" style={{ marginRight: '8px' }}></i>Earn extra income & ease your expenses.</li>
                                        <li className="mt-3"><i class="fa fa-chevron-circle-right" aria-hidden="true" style={{ marginRight: '8px' }}></i>Spread your knowledge to help millions of students</li>
                                        <li className="mt-3"><i class="fa fa-chevron-circle-right" aria-hidden="true" style={{ marginRight: '8px' }}></i>Help Students with Experts Mentorship</li>
                                        <li className="mt-3"><i class="fa fa-chevron-circle-right" aria-hidden="true" style={{ marginRight: '8px' }}></i>Interact with other likeminded teachers</li>
                                        <li className="mt-3"><i class="fa fa-chevron-circle-right" aria-hidden="true" style={{ marginRight: '8px' }}></i>CareerGrads is there to help you at every step</li>
                                    </ul>
                                </div>
                                <div className="mt-3">
                                    <NavLink to="/market-place" class="btn btn-primary p2 rounded rounded-2 bg-gradient ml-3">Become a Tutor</NavLink>
                                </div>
                            </div>
                            <div className="col-10 col-md-6 order-1 order-lg-2 mx-auto text-center">
                                <img src={learn} alt="sample" className="img-fluid img-responsive " style={{ width: "28rem" }} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            {/* --------------------------- who we are and what we do...-------------------------------------- */}


            <div className="container-fluid ">
                <div className="container">
                    <h1 className="my-4 myborder">
                        <strong>Who we are &
                        What we do
                                </strong>
                    </h1>
                </div>
                <div className="text-center my-5">
                    <div className="row">
                        <div className="col-sm-4 col-12 mx-auto m-4 p-3 ">
                            <img src={one} className="img-fluid img-responsive m-3 " style={{ width: "12rem" }} />
                            <h3>Free Lectures</h3>
                            <p>Binge through our free lectures and videos.</p>
                        </div>
                        <div className="col-sm-4 col-12 mx-auto m-4 p-3 ">
                            <img src={two} className="img-fluid img-responsive m-3" style={{ width: "12rem" }} />
                            <h3>Industry-standard training</h3>
                            <p>For those seeking a job. We are here to upskill you.</p>

                        </div>
                        <div className="col-sm-4 col-12 mx-auto m-4 p-3 ">
                            <img src={three} className="img-fluid img-responsive m-3" style={{ width: "12rem" }} />
                            <h3>Placement Cell</h3>
                            <p>Offering interview preparation and opportunities to all enrolled students.</p>

                        </div>
                        <div className="col-sm-4 col-12 mx-auto m-4 p-3 ">
                            <img src={four} className="img-fluid img-responsive m-3" style={{ width: "12rem" }} />
                            <h3>Certifications and Projects</h3>
                            <p>Need to be certified on a topic. Or want practical exposure through projects. Join us!</p>

                        </div>
                        <div className="col-sm-4 col-12 mx-auto m-4 p-3 ">
                            <img src={five} className="img-fluid img-responsive m-3" style={{ width: "12rem" }} />
                            <h3>Counselling sessions</h3>
                            <p>Confused about your next step? Contact us!</p>
                        </div>
                        <div className="col-sm-4 col-12 mx-auto m-4 p-3 ">
                            <img src={five} className="img-fluid img-responsive m-3" style={{ width: "12rem" }} />
                            <h3>Group Tutoring</h3>
                            <p>Need training for your organisation/school/college? Feel free to discuss with us.</p>
                        </div>
                    </div>
                </div>
            </div>

            <div className="container " >
                    <div className="p-4 d-flex justify-content-center align-items-center text-center border rounded-2 bg-white shadow-sm mx-auto"
                     style={{ margin: "-10px 0 0 0" }}>
                        <img src="https://img.icons8.com/color/96/000000/callback.png" 
                        style={{width:"70px",height:"70px"}} className=" animate__animated animate__bounce"/>
                        <h4>
                            Tell Us Your Problem <span className="font-weight-bold text-primary">We Will Connect With You </span>and Lead you to the right Career Path.
                        </h4>
                    </div>
                    
                    </div>


            {/* --------------------------- Why choose us...-------------------------------------- */}

            <div className="container-fluid  p-5 service" style={{ margin: "12% 0" }}>
                <div className="container ">
                    <div className="text-left ">
                        <h1 className="font-weight-bold text-white">
                            Why Choose Us?
                        </h1>
                    </div>
                    <div className="row ">
                        <div className="col-sm-12 col-lg-6 col-md-6 mx-auto d-flex flex-column justify-content-center">
                            <h5 className="text-left my-auto my-sm-4 text-white" style={{ fontSize: "1.8rem" }}>
                                CareerGrads Brings To You:
                                
                            </h5>
                            <ul className=" list_style text-left" >
                                    <li className="mt-3 text-white"><i class="fa fa-chevron-circle-right" aria-hidden="true" style={{ marginRight: '8px' }}></i> Industry-standard trainings and courses.</li>
                                    <li className="mt-3 text-white"><i class="fa fa-chevron-circle-right" aria-hidden="true" style={{ marginRight: '8px' }}></i>Help you get your dream job and gain insights into projects & corporate work. </li>
                                    <li className="mt-3 text-white"><i class="fa fa-chevron-circle-right" aria-hidden="true" style={{ marginRight: '8px' }}></i>Placement cell which will guide you throughout the enrollment duration.</li>
                                </ul>
                            <NavLink to='/contact'
                                className="btn my-auto w-50 btn-secondary bg-gradient my-sm-4 "
                            >Contact Us.</NavLink>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12 mx-auto text-right">
                            <img className="img-responsive img-fluid" src={chooseus} alt="" style={{ width: "28rem" }} />
                        </div>
                    </div>

                </div>

            </div>
            {/* --------------------------- Video Section...-------------------------------------- */}

            <div className="container-fluid my-4">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 col-md-6 col-sm-12 mx-auto text-center" style={{borderRight:"2px solid lightblue" }}>
                            <h2>
                                Maths <strong style={{color:"cornflowerblue"}}>Live & Recorded</strong> Sessions
                            </h2>
                            <iframe src="https://drive.google.com/file/d/1JHKzcoVnSZYoQI9YDtSHih3gURJHjq1a/preview" 
                            className="video-container video-container-overlay my-5 video" controls >
                            </iframe>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12 mx-auto text-center ">
                            <h2>
                                Science <strong style={{color:"cornflowerblue"}}>Live & Recorded</strong> Sessions
                            </h2>
                            <iframe src="https://drive.google.com/file/d/1wBGPLxn6EBhQHJTldfFPSPICdfgYlhBq/preview" 
                            className="video-container video-container-overlay my-5 video" controls >
                            </iframe>
                        </div>
                    </div>
                </div>
            </div>

            {/* --------------------------- Download App...-------------------------------------- */}
            <div className="container-fluid my-5">
                <img src={blob} alt="blob" className="blob" />
                <section className="d-flex align-items-center">
                    <div className="container-fluid">

                        <div className="row">
                            <div className="col-10 mx-auto">
                                <div className="row">
                                    <div
                                        className="col-md-6 pt-5 order-2 order-lg-2">
                                        <div className="my-2">
                                            <h2>Get Our Application and stay connected</h2>
                                        </div>

                                        <h2 className="my-3 font-weight-bold">
                                            Download Now For Free!</h2>
                                        <p>
                                        <strong className="text-primary">CareerGrads </strong>provides a 360 coverage of all your 
                                            <strong className="text-primary"> Educational problems. </strong>
                                            We have all content that a Brilliant Child needs.
                                            On Our Application we have thousands of <strong className="text-primary">Live & Recorded Classes </strong>
                                             curated from our own in house mentors. 
                                            </p>
                                        <div className="row my-4">
                                            <div className="col-lg-6 mx-auto col-10 text-left p-0 m-3">
                                                <a href="https://play.google.com/store/apps/details?id=com.career_grads"><img
                                                    src={"https://upload.wikimedia.org/wikipedia/commons/thumb/7/78/Google_Play_Store_badge_EN.svg/1280px-Google_Play_Store_badge_EN.svg.png"}
                                                    alt="appstore"
                                                    style={{ width: "230px", height: "60px", cursor: "pointer" }}
                                                    className="img-responsive img-fluid drop_shadow"
                                                /></a>
                                            </div>

                                            <div className="col-lg-6 col-10 mx-auto p-0 m-3">
                                                <img
                                                    src={"https://upload.wikimedia.org/wikipedia/commons/thumb/3/3c/Download_on_the_App_Store_Badge.svg/1280px-Download_on_the_App_Store_Badge.svg.png"}
                                                    alt="appstore"
                                                    className="img-responsive img-fluid drop_shadow"
                                                    style={{ width: "230px", height: "60px", cursor: "pointer" }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-6 mx-auto order-1 order-lg-1 header-img text-center">
                                        <img
                                            src={mockup}
                                            alt="header-img"
                                            className="img-fluid drop_shadow"
                                            style={{ width: "280px", height: "550px" }}
                                        />

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            {
                window.scrollTo(0, 0)
            }

        </>
    )
}

export default Home
